import axiosInstance from "./axiosInstance";

export async function getBanks(){
    let result = await axiosInstance.get("banks").catch(err=>console.log(err))
    return result
}

export function getBranches(page = 1) {

    console.log(page);
    return new Promise((resolve, reject) => {
        axiosInstance.get("/branches", {
            params: {
                page
            }
        }).then(res => resolve(res.data))
    })
}

export function getPaginatedBranches(next) {
    const page = next?.split("=")[1]
    
    return getBranches(page);
}

export function getBankCategories(page=1 ,bank){
    console.log("page1" + page)
    return new Promise((resolve, reject) => {
        axiosInstance.get(`/get_category/${bank}`, {
            params: {
                page,
            }
        }).then(res => resolve(res.data)).then(e => reject(e));
    })
}
export function getPaginatedBankCategories(bank, next ) {
    let page;
    if(next){
        console.log("next" + next)

        page = next?.split("=")[1]
        console.log("page" + page)
    }
    return getBankCategories(page ,bank);
}


export function getPermCategories(page = 1) {
    return new Promise((resolve, reject) => {
        axiosInstance.get("/get_category", {
            params: {
                page,
            }
        }).then(res => resolve(res.data)).then(e => reject(e));
    })
}

export function getPermJobs(page = 1) {
    return new Promise((resolve, reject) => {
        axiosInstance.get("/get_job", {
            params: {
                page,
            }
        }).then(res => resolve(res.data)).then(e => reject(e));
    })
}


export function sendSign(data){
    let formData = new FormData()
    for (let key in data){
        formData.append(key , data[key])
    }
    console.log(data);
    return new Promise((resolve, reject) => {
        axiosInstance.post("/signature", formData).then(res => resolve(res)).then(e => reject(e));
    })
}

export function editSign(data , id){
    let formData = new FormData()
    
    for(let key in data){
        if(!(data[key] === null || data[key]=== "")){
            formData.append(key , data[key])
        }
    }
    console.log(data);
    return new Promise((resolve, reject) => {
        axiosInstance.put(`/signature/${id}`, formData).then(res => resolve(res)).then(e => reject(e));
    })

    }

export async function search(data){
    console.log(data)
    for(let key in data){
        if(data[key] === undefined){
            delete data[key]
        }
    }
    let result = await axiosInstance.get(`/get_signature?signee_name_ar=${data.signee_name_ar ?data.signee_name_ar : "" }&signee_name_en=${data.signee_name_en ? data.signee_name_en : ""}&bank_branch=${data.bank_branch ? data.bank_branch : ""}&category=${data.category ? data.category : ""}&job=${data.job ? data.job : ""}&avaliable_from=${data.avaliable_from ? data.avaliable_from : ""}&bank=${data.bank}`)
    .catch(err=>{
        console.log(err)
    })
    if(result){
        console.log(result)
    }
    return result
}

export async function searchUpdate(data){
    for(let key in data){
        if(data[key] === undefined){
            delete data[key]
        }
    }
    let result = await axiosInstance.get(`/search_signature?signee_name_ar=${data.signee_name_ar ?data.signee_name_ar : "" }&signee_name_en=${data.signee_name_en ? data.signee_name_en : ""}&bank_branch=${data.bank_branch ? data.bank_branch : ""}&category=${data.category ? data.category : ""}&job=${data.job ? data.job : ""}&avaliable_from=${data.avaliable_from ? data.avaliable_from : ""}`)
    .catch(err=>{
        console.log(err)
    })
    if(result){
        console.log(result)
    }
    return result
}